import { User } from 'lucide-react';
import { FormField, TextInput, CountryTypeahead } from '../form-fields';
import { UserInfoFormData } from '../hooks/useUserInfoForm';

interface Step1PersonalInfoProps {
  formData: UserInfoFormData;
  loading: boolean;
  updateField: (field: keyof UserInfoFormData, value: string) => void;
  wiggleFields: Set<string>;
}

export function Step1PersonalInfo({
  formData,
  loading,
  updateField,
  wiggleFields,
}: Step1PersonalInfoProps) {
  return (
    <div className="space-y-4">
      {/* Step Header */}
      <div className="text-center">
        <h2 className="text-lg font-medium text-theme-light-text-primary dark:text-theme-dark-text-primary mb-1">
          Personal Information
        </h2>
        <p className="text-sm text-theme-light-text-secondary dark:text-theme-dark-text-secondary">
          Let's start with your basic information
        </p>
      </div>

      {/* Form Fields */}
      <div className="space-y-4">
        {/* Display Name Field */}
        <div className={wiggleFields.has('displayName') ? 'wiggle-animation' : ''}>
          <FormField label="Display Name" htmlFor="displayName" required>
            <TextInput
              id="displayName"
              name="displayName"
              placeholder="Enter your full name"
              value={formData.displayName}
              onChange={(e) => updateField('displayName', e.target.value)}
              disabled={loading}
              required
              icon={User}
            />
          </FormField>
        </div>

        {/* Country Field */}
        <div className={wiggleFields.has('country') ? 'wiggle-animation' : ''}>
          <FormField label="Country" htmlFor="country" required>
            <CountryTypeahead
              value={formData.country}
              onChange={(val) => updateField('country', val)}
              disabled={loading}
            />
          </FormField>
        </div>
      </div>
    </div>
  );
}
